import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconInputGroupComponent } from './components/icon-input-group/icon-input-group.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { IconSelectGroupComponent } from './components/icon-select-group/icon-select-group.component';
import { SelectableCardComponent } from './components/selectable-card/selectable-card.component';
import { LayoutComponent } from './layout/layout.component';
import { CircleLoaderComponent } from './components/circle-loader/circle-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalBasicComponent } from './components/modal-basic/modal-basic.component';
import { CounterComponent } from './components/counter/counter.component';
import { BlankComponent } from './components/blank/blank.component';
import { MatDividerModule } from '@angular/material/divider';
import {
  File,
  Database,
  TrendingUp,
  ArrowRightCircle,
  ArrowLeft,
  FileText,
  List,
  Info,
  Phone,
  Mail,
  Settings,
  LogOut,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Home,
  Search,
  PieChart,
  Calendar,
  Trash2,
  X,
  Edit2,
  CreditCard,  Plus,  Minus, DollarSign,
  UserCheck,
  CheckCircle
} from 'angular-feather/icons';
import { FeatherModule } from 'angular-feather';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { OverLoadingComponent } from './components/over-loading/over-loading.component';
import { ModalRedirectComponent } from './components/modal-redirect/modal-redirect.component';
import { MatButtonModule } from '@angular/material/button';
import { ModalTimeoutComponent } from './components/modal-timeout/modal-timeout.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { MessageBasicComponent } from './components/message-basic/message-basic.component';
import { SelectableReversesCardComponent } from './components/selectable-reverses-card/selectable-reverses-card.component';
import { FixedBarComponent } from './components/fixed-bar/fixed-bar.component';
import { PageConfirmComponent } from './components/page-confirm/page-confirm.component';
import { BankDataComponent } from './components/banck-data/bank-data.component';
import { MyCornet } from '../shared/utils/extends/feather-icons/myCornet';
import { MyEqual } from '../shared/utils/extends/feather-icons/myEqual';
import { MyMoneys } from '../shared/utils/extends/feather-icons/myMoneys';
import { MyCard } from '../shared/utils/extends/feather-icons/myCard';
import { MyCardUp } from '../shared/utils/extends/feather-icons/myCardUp';
import { MyCardDown } from '../shared/utils/extends/feather-icons/myCardDown';
import { MyCard2 } from '../shared/utils/extends/feather-icons/myCard2';
import { GraficoFondosComponent } from './components/grafico-fondos/grafico-fondos.component';
import { ChartsModule } from 'ng2-charts';
import { GraficoRendimientosComponent } from '../modules/private/modules/rendimientos/theme/sections/grafico-rendimientos/grafico-rendimientos.component';
import { MyMinus } from '../shared/utils/extends/feather-icons/myMinus';
import { MyPlus } from '../shared/utils/extends/feather-icons/myPlus';
import { ModalSessionComponent } from './components/modal-session/modal-session.component';
import { ModalPerfilInversionistaComponent } from './layout/modal-perfil-inversionista/modal-perfil-inversionista.component';
import { MatRadioModule } from '@angular/material/radio';
import { ModalPerfilResumeComponent } from './layout/modal-perfil-inversionista/modal-perfil-resume/modal-perfil-resume.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ValidateNextBtnPipe } from './layout/modal-perfil-inversionista/modal-perfil-resume/validate-next-btn.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { MessageAlertComponent } from './components/message-alert/message-alert.component';
import { ModalResponseComponent } from './components/modal-response/modal-response.component';
import { MyExclam } from '../shared/utils/extends/feather-icons/myExclam';

const icons = {
  File,
  Database,
  TrendingUp,
  ArrowRightCircle,
  ArrowLeft,
  FileText,
  List,
  Search,
  Info,
  CheckCircle,
  Phone,
  Mail,
  Settings,
  LogOut,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Home,
  PieChart,
  Calendar,
  Trash2,
  X,
  Edit2,
  CreditCard, Plus, Minus, DollarSign, UserCheck,
  Cornet: MyCornet, Equal: MyEqual, Moneys: MyMoneys, Card: MyCard, Card2: MyCard2, CardUp: MyCardUp, CardDown: MyCardDown,
  Plus2: MyPlus, Minus2: MyMinus, Exclam: MyExclam
};

@NgModule({
    declarations: [
        IconInputGroupComponent,
        IconSelectGroupComponent,
        SelectableCardComponent,
        LayoutComponent,
        CircleLoaderComponent,
        ModalBasicComponent,
        CounterComponent,
        BlankComponent,
        OverLoadingComponent,
        ModalRedirectComponent,
        ModalTimeoutComponent,
        PageHeaderComponent,
        MessageBasicComponent,
        MessageAlertComponent,
        SelectableReversesCardComponent,
        FixedBarComponent,
        PageConfirmComponent,
        BankDataComponent,
        GraficoFondosComponent,
        GraficoRendimientosComponent,
        ModalSessionComponent,
        ModalPerfilInversionistaComponent,
        ModalPerfilResumeComponent,
        ValidateNextBtnPipe,
        ModalResponseComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        NgxSkeletonLoaderModule,
        FeatherModule.pick(icons),
        MatDividerModule,
        ChartsModule,
        MatRadioModule,
        MatCheckboxModule,
        NgxMaskModule.forRoot(),
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        IconInputGroupComponent,
        IconSelectGroupComponent,
        SelectableCardComponent,
        CircleLoaderComponent,
        CounterComponent,
        ModalBasicComponent,
        OverLoadingComponent,
        PageHeaderComponent,
        MessageBasicComponent,
        MessageAlertComponent,
        BankDataComponent,
        SelectableReversesCardComponent,
        FixedBarComponent,
        PageConfirmComponent,
        FeatherModule,
        GraficoFondosComponent,
        GraficoRendimientosComponent,
        ModalResponseComponent
    ]
})
export class ThemeModule { }
